import React from 'react'
// import { useNavigate } from 'react-router-dom';

const ProjectCard = ({image,name}) => {
    // const navigate = useNavigate();
    return (
      <div className="relative bg-white border rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 transform transition duration-500 hover:scale-100">
        <div style={{ backgroundImage: `url(${image})` }} className='spacialu bg-cover h-80  w-96 sm:w-72 md:w-80 lg:w-96 sm:h-48 md:h-60 lg:h-60  rounded-md' />
      </div>
  )
}

export default ProjectCard


